<template>
  <div class="teachers">
    <br>
    <div v-if="error">
      {{ error }}
      <Spinner />
    </div>
    <div
      v-if="learners"
      class="layout"
    >
      <br>
      <div class="flex collapse">
        <h2>Learner Records</h2>
        <div class="flex">
        <select
          v-model="grade"
        >
          <option
            value="Baby Class"
            selected="selected"
          >
          Baby Class
          </option>
          <option value="Middle Class">
            Middle Class
          </option>
          <option value="Reception Class">
            Reception
          </option>
          <option value="Grade 1">
            Grade 1
          </option>
          <option value="Grade 2">
            Grade 2
          </option>
          <option value="Grade 3">
            Grade 3
          </option>
          <option value="Grade 4">
            Grade 4
          </option>
          <option value="Grade 5">
            Grade 5
          </option>
          <option value="Grade 6">
            Grade 6
          </option>
          <option value="Grade 7">
            Grade 7
          </option>
          <option value="clear" selected>
            Show all
          </option>
        </select>
        </div>
        <ChevronUpIcon class="icone" @click="toggleLearners" v-if="showLearners" />
        <ChevronDownIcon class="icone" @click="toggleLearners" v-if="!showLearners" />
      </div>
      <div v-if="showLearners">
        <div class="totals">
          <span v-if="grade !== 'clear'">Leaders in {{ filteredLearners[0].grade }}: </span>
          <span v-if="grade === 'clear'">Total Leaders in School: </span>
          {{ filteredLearners.length }}
        </div>
        <div
          v-for="learner in filteredLearners"
          :key="learner.uid"
        >
          <SchoolRecords :record="learner" @toasts="refetch" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="card"
    >
      <Spinner />
    </div>
  </div>
</template>

<script>
import getListOfUsers from '@/composables/getListOfUsers'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/outline'
import SchoolRecords from './SchoolRecords.vue'
import Spinner from '@/components/Spinner.vue'
import { ref } from '@vue/reactivity'
import { watchEffect } from '@vue/runtime-core'

export default {
  name: 'LearnerRecords',
  components: { SchoolRecords, Spinner, ChevronDownIcon, ChevronUpIcon },
  setup (props, context) {
    const showLearners = ref(false)
    const grade = ref(null)
    const filteredLearners = ref(null)
    const { learners, error, fetchListOfUsers } = getListOfUsers()

    fetchListOfUsers()

    watchEffect(() => {
      if (grade.value === null) {
        filteredLearners.value =
        learners.value ? learners.value.map((record, index) => ({ ...record, rank: index + 1 }))
          : null
      }
      if (grade.value === 'clear') {
        filteredLearners.value =
        learners.value ? learners.value.map((record, index) => ({ ...record, rank: index + 1 }))
          : null
      } else {
        filteredLearners.value =
        learners.value ? learners.value.filter(learner => learner.grade === grade.value).map((record, index) => ({ ...record, rank: index + 1 }))
          : null
      }
    })

    const toggleLearners = () => {
      showLearners.value = !showLearners.value
    }
    const refetch = () => {
      context.emit('toasts')
    }
    return { learners, error, refetch, showLearners, toggleLearners, grade, filteredLearners }
  }
}
</script>

<style>
.teachers .collapse {
  justify-content: space-between;
}
.teachers .collapse select {
  border-radius: 20px;
  background: #eee;
  margin: 0;
  padding: 0;
}
.teachers .icone {
  max-width: 30px;
  cursor: pointer;
  color: white;
}
.teachers .totals {
  background-color: #eee;
  color: #000;
  padding: 10px;
  margin: 7px;
  font-size: 1.1em;
  border-radius: 20px;
}
</style>
